import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error(
    "Missing Supabase config. Set REACT_APP_SUPABASE_URL and " +
    "REACT_APP_SUPABASE_ANON_KEY — locally via .env.local, in CI/CD via " +
    "your hosting provider's environment variable settings."
  );
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
